var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 400 233.34"}},[_c('path',{pre:true,attrs:{"d":"M176.43,9.77c13.02-13.02,34.12-13.02,47.14,0l166.67,166.67c13.01,13.01,13.01,34.12,0,47.14-13.02,13.02-34.12,13.02-47.14,0L200,80.48,56.9,223.58c-13.02,13.02-34.12,13.02-47.14,0s-13.02-34.12,0-47.14L176.43,9.77Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }